export default function Arr2str (arr: any) {
  var str = arr.toString();
  var res = str.replace(',', ' ');
  while(res !== str) {
    str = str.replace(',', ' ');
    res = res.replace(',', ' ');
  }
  return res;
}
